<template>
    <rkm-data-table
        :fields="fields"
        :repository="repositories.cadastro.bairro"
        ref="RkmDataTable"
    >
        <template v-slot:cell(actions)="{ item }">
            <rkm-button
                v-if="authorize('cadastro-bairro-update')"
                :to="{name: 'cadastro-bairro-edit', params: {id: item.bairro_id}}"
                color="primary"
                small
                title="Editar"
                v-rkm-tooltip.hover
            >
                <rkm-icon icon="pen" />
            </rkm-button>

            <rkm-button
                v-if="authorize('cadastro-bairro-destroy')"
                @click="handleDestroy(item)"
                color="danger"
                small
                title="Excluir"
                v-rkm-tooltip.hover
            >
                <rkm-icon icon="trash" />
            </rkm-button>
        </template>
    </rkm-data-table>
</template>

<script>
// Mixins.
import {authorization, error, notification} from '@/mixins'

export default {
    computed: {
        fields() {
            return [
                {
                    key: 'estado_uf',
                    label: 'UF',
                    name: 'cadastro_estado.uf',
                    searchable: true,
                    sortable: true,
                },
                {
                    class: 'col-4',
                    key: 'municipio_nome',
                    label: 'Município',
                    name: 'cadastro_municipio.nome',
                    searchable: true,
                    sortable: true,
                },
                {
                    key: 'bairro_nome',
                    label: 'Nome',
                    name: 'cadastro_bairro.nome',
                    searchable: true,
                    sortable: true,
                },
                {
                    class: 'col-min text-center',
                    key: 'actions',
                    label: 'Ações',
                },
            ]
        },
    },
    inject: ['repositories'],
    methods: {
        handleDestroy(item) {
            const destroy = () => this.repositories.cadastro.bairro.destroy(item.bairro_id)
                .then(() => this.$refs.RkmDataTable.refresh())

            this.showDangerConfirmation('Confirmação', `Deseja realmente excluir o bairro ${item.bairro_nome}?`, destroy, this.handleError)
        },
    },
    mixins: [authorization, error, notification],
}
</script>